import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocaleCode from 'locale-code';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Button, Dropdown, MenuItem } from 'react-bootstrap';
import { transalteLanguageCode } from '../../../../util/helpers';

import {
  updateCollectorLanguageMappings,
} from '../../../Auth/AuthActions';

// Import Selectors
import {
  getCollectorLanguageMappings,
} from '../../../Auth/AuthReducer';


class CollectorLanguageMappingForm extends Component {
  constructor() {
    super();
    this.state = {
      loading: {},
    };
    this.cancel = this.cancel.bind(this);
    this.valueSetter = this.valueSetter.bind(this);
  }

  cancel() {
    this.props.onCancel();
  }

  getKey(mapping) {
    return `${mapping.collector_type}|${mapping.collector_id}`; 
  }

  valueSetter(params) {
    const { data, newValue } = params;
    if (data.selected_language === newValue) {
      return false;
    }
    const k = this.getKey(data);
    if (this.state.loading[k]) {
      return false;
    }
    this.setState({ loading: { ...this.state.loading, [k]: true } }, () => {
      const val = {
        collector_id: data.collector_id,
        type: data.collector_type,
        language: newValue,
      };
      this.props.dispatch(updateCollectorLanguageMappings([val]))
        .then(
          () => {
            this.setState({ loading: { ...this.state.loading, [k]: false } });
          },
          () => {
  
          },
        );
    });
    return true;
  }


  renderMapping(mapping, i) {
    const k = this.getKey(mapping);
    const disabled = this.state.loading[k];
    let selected = mapping.selected_language ? LocaleCode.getLanguageNativeName(transalteLanguageCode(mapping.selected_language)) : 'select a language';
    const hasSelected = mapping.selected_language !== undefined;
    const usingDefault = mapping.selected_language === null;
    if (usingDefault) {
      selected = 'Use collector default language';
    }
    return (
      <tr key={k} className={!hasSelected ? 'warning' : 'success'}>
        <td>{i}.</td>
        <td>
          <strong>{mapping.collector_name}</strong><br />
          <span className="text-uppercase label label-default">{mapping.collector_type} Collector</span>
        </td>
        <td>
          <Dropdown
            disabled={disabled}
            id={k}
            onSelect={this.valueSetter}
          >
            <Dropdown.Toggle disabled={disabled}>
              <span>{selected}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {hasSelected && <MenuItem header>Select a language:</MenuItem>}
              {(mapping.used_languages || []).map((lang) => {
                return (
                  <MenuItem
                    active={mapping.selected_language === lang}
                    eventKey={{ data: mapping, newValue: lang }}
                    key={lang}
                  >
                    {LocaleCode.getLanguageNativeName(transalteLanguageCode(lang))}
                  </MenuItem>
                );
              })}
              <MenuItem divider />
              <MenuItem
                active={mapping.selected_language === null}
                eventKey={{ data: mapping, newValue: null }}
              >
                <em>Use collector default language</em>
              </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>
    );
  }

  render() {
    const { showCancel, mappings } = this.props;
    return (
      <div>
        <div>
          <table className="table">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Collector</th>
                <th>Language</th>
              </tr>
            </thead>
            <tbody>
              {mappings.map((mapping, i) => this.renderMapping(mapping, i + 1))}
            </tbody>
          </table>
        </div>
        <p />
        <div className="clearfix">
          {showCancel && <Button className="pull-right" bsStyle="link" onClick={this.cancel}>Done</Button>}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    mappings: getCollectorLanguageMappings(state),
  };
}

CollectorLanguageMappingForm.propTypes = {
  dispatch: PropTypes.func.isRequired,
  mappings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onCancel: PropTypes.func,
  showCancel: PropTypes.bool,
};
CollectorLanguageMappingForm.defaultProps = {
  mappings: [],
  onCancel: () => {},
  showCancel: false,
};
CollectorLanguageMappingForm.contextTypes = {
};


export default connect(mapStateToProps)(CollectorLanguageMappingForm);
